import React, { useState, useEffect } from 'react';
import ImageLightbox from '../ImageLightbox';

const MediaPoster = ({
  mediaItem,
  isAdmin,
  onOpenImagePicker,
}) => {
  const [imageError, setImageError] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  useEffect(() => {
    // Reset image error state when mediaItem changes
    setImageError(false);
  }, [mediaItem?.vertical_image]);

  const onImageError = () => {
    console.error(`Failed to load image for ${mediaItem.type}: ${mediaItem.vertical_image}`);
    setImageError(true);
  };

  const hasImage = !imageError && mediaItem?.vertical_image;

  return (
    <section className="poster-section">
      <div className="poster-image-wrapper">
        {hasImage ? (
          <img
            src={mediaItem.vertical_image}
            alt={`${mediaItem.title} poster`}
            className="poster-img"
            onError={onImageError}
            onClick={() => setLightboxOpen(true)}
          />
        ) : (
          <div className="poster-placeholder">
            {mediaItem?.type === 'Anime' || mediaItem?.type === 'AnimeMovie' || mediaItem?.type === 'AnimeSerie'
              ? 'Anime Image Unavailable'
              : 'No Image Available'}
          </div>
        )}
        {isAdmin && (
          <button type="button" className="poster-change-btn" onClick={() => onOpenImagePicker?.('vertical')}>
            <img src="/static/icons/pen-to-square-solid.svg" alt="" className="icon" />
            Change Poster
          </button>
        )}
      </div>
      <ImageLightbox
        isOpen={lightboxOpen}
        src={mediaItem?.vertical_image}
        alt={`${mediaItem?.title} poster`}
        onClose={() => setLightboxOpen(false)}
      />
    </section>
  );
};

export default MediaPoster;